<template>
  <v-container
    fluid
    class="pa-0 ma-0"
  >
    <v-fade-transition mode="out-in">
      <router-view
        v-if="$route.name !== routeName"
        class="mt-2"
      />

      <v-row
        v-else
        no-gutters
        class="pa-0 ma-0"
      >
        <v-container
          fluid
        >
          <v-row
            v-if="title"
            no-gutters
          >
            <v-col cols="12">
              <MainTitle
                :title="title"
                :icon="icon"
                :image="image"
              />
            </v-col>
          </v-row>
          <v-row
            justify="center"
            align="stretch"
          >
            <v-col
              cols="12"
              class="text-center"
            >
              <slot name="top" />
            </v-col>
            <v-col
              v-for="(category, i) in categoryListAuth"
              :key="i"
              sm="6"
              xs="12"
              md="6"
              lg="3"
            >
              <v-card class="fill-height">
                <v-card-text class="text-center">
                  <v-icon
                    v-if="category.icon"
                    x-large
                    class="accent--text"
                  >
                    {{ category.icon }}
                  </v-icon>
                  <div class="headline text-center">
                    {{ category.title }}
                  </div>
                  <div class="mt-2">
                    {{ category.description }}
                  </div>
                </v-card-text>
                <v-card-actions v-if="!category.actions">
                  <v-spacer />
                  <v-btn
                    :to="category.to"
                    text
                    color="accent"
                  >
                    Accéder à cette zone
                    <v-icon dark>
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>
                </v-card-actions>
                <v-card-actions
                  v-else
                  class="justify-center"
                >
                  <v-btn
                    v-for="(action, actionIndex) in category.actions"
                    :key="actionIndex"
                    :to="action.to"
                    :text="!!action.text"
                    color="accent"
                  >
                    <v-icon
                      v-if="action.iconBefore"
                      dark
                      left
                    >
                      {{ action.iconBefore }}
                    </v-icon>
                    {{ action.text }}
                    <v-icon
                      v-if="action.iconAfter"
                      dark
                      right
                    >
                      {{ action.iconAfter }}
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              class="text-center"
            >
              <slot name="bottom" />
            </v-col>
          </v-row>
        </v-container>
      </v-row>
    </v-fade-transition>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import MainTitle from './MainTitle'

export default {
  name: 'CategoryPage',
  components: { MainTitle },
  props: {
    categoryList: {
      type: Array,
      default: () => []
    },
    title: {
      type: [Boolean, String],
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    routeName: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('user', ['hasOneOfPermissions']),
    categoryListAuth () {
      return this.categoryList.filter(category => !category.credentials || this.hasOneOfPermissions(category.credentials))
    }
  }
}
</script>
<style>
</style>
